/**
 * Use this in a switch statement's default case to ensure that all cases are handled.
 */
export function assertUnreachable(_x: never): never {
  throw new Error("Didn't expect to get here: " + JSON.stringify(_x))
}
